import { apiSlice } from "app/api/apiSlice"


export const privacyPolicyApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['PrivacyPolicy'],
    endpoints: builder => ({
        getPrivacyPolicy: builder.query({
            query: () => 'privacy',
            keepUnusedDataFor: 5,
            providesTags: ['PrivacyPolicy']
        }),
        getPrivacyPolicyStatus: builder.query({
            query: () => 'privacy/status',
            keepUnusedDataFor: 0,
        }),
        getPrivacyPolicyTemplate: builder.query({
            query: () => 'privacy/template',
            keepUnusedDataFor: 5,
            providesTags: ['PrivacyPolicy']
        }),
        getPrivacyPolicyDetails: builder.query({
            query: () => 'privacy/detail',
            keepUnusedDataFor: 5,
            providesTags: ['PrivacyPolicy']
        }),
        createOrUpdatePrivacyPolicy: builder.mutation({
            query: data => ({
                url: 'privacy/template',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['PrivacyPolicy']
        }),
        acceptPrivacyPolicy: builder.mutation({
            query: data => ({
                url: 'privacy/accept',
                method: 'POST'
            })
        }),

    })
})

export const {
    useGetPrivacyPolicyQuery,
    useGetPrivacyPolicyStatusQuery,
    useGetPrivacyPolicyTemplateQuery,
    useGetPrivacyPolicyDetailsQuery,
    useCreateOrUpdatePrivacyPolicyMutation,
    useAcceptPrivacyPolicyMutation
} = privacyPolicyApiSlice